import { render, staticRenderFns } from "./EmptyStockProduct.vue?vue&type=template&id=10be1402&scoped=true&"
import script from "./EmptyStockProduct.vue?vue&type=script&lang=js&"
export * from "./EmptyStockProduct.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStockProduct.vue?vue&type=style&index=0&id=10be1402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be1402",
  null
  
)

export default component.exports